var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-card-container',{attrs:{"centered":"","title":_vm.$t('menu.mycompany')}},[(_vm.company)?_c('my-company-form',{attrs:{"value":_vm.value,"loading":_vm.loading},on:{"input":_vm.onInput}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }